export const getTracesSampleRate = (host, operation) => {
  if (host.includes('test') || host.includes('staging')) return 1.0
  if (operation == 'pageload') return 1.0
  return 0.0
}
